module.exports = __webpack_public_path__ + "img/backgroundImageDiplomaDefault.23c0df3.PNG";